import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

import { AD_LAYOUT_STUBS } from "@consts";
import { getDateDataFromDateCode, newsArticleSchema } from "@utils";
import { getContextoAnswers } from "@/common/services/contextoService";

dayjs.extend(utc);
dayjs.extend(tz);

export default {
	name: "Contexto",
	data() {
		return {
			AD_LAYOUT_STUBS,
			showAnswer: false,
			todayData: null,
			pastData: [],
			tableHeaders: ["Date", "Contexto Puzzle", "Contexto Answer"],
		};
	},
	async asyncData({ $axios, $config, res }) {
		let serviceResponse = null;

		if (!process.client) {
			serviceResponse = await getContextoAnswers($axios, $config);

			// Set cache expiration header:
			if (res) {
				const now = dayjs().tz("America/New_York");
				let nextRefreshDate = dayjs()
					.utc()
					.hour(0)
					.minute(0)
					.startOf("minute");
				if (nextRefreshDate.isBefore(now)) {
					// Same time tomorrow
					nextRefreshDate = nextRefreshDate.add(1, "day");
				}
				const expirationDate = nextRefreshDate
					.utc()
					.format("ddd, DD MMM YYYY HH:mm:ss [GMT]");

				res.setHeader("Expires", expirationDate);
			}
		}

		return {
			isClientMode: process.client,
			todayData: serviceResponse?.today || null,
			pastData: serviceResponse?.past || [],
		};
	},
	head() {
		const today = getDateDataFromDateCode(this.todayData?.date);
		const metaTitle = this.$t(this.$route.meta.title, {
			MonthDay: `${today.month} ${today.day}`,
		});
		return {
			title: metaTitle,
			script: [
				newsArticleSchema({
					headline: metaTitle,
					image: "https://wordfinder.yourdictionary.com/static/images/contexto-og.jpg",
					datePublished: "2022-12-20T08:00:00.000Z",
				}),
			],
		};
	},
	computed: {
		answerHeading() {
			if (!this.todayData) {
				return null;
			}

			const strings = [
				`Today's Contexto Answer (#${this.todayData.index})`,
				this.dateString,
			];

			return strings.join(this.isSmallDevice ? "<br />" : " - ");
		},
		dateString() {
			const date = getDateDataFromDateCode(this.todayData.date);
			return `${date.month} ${date.day}, ${date.year}`;
		},
		pastAnswers() {
			if (!Array.isArray(this.pastData) || !this.pastData.length) {
				return [];
			}

			return this.pastData.map((group) => {
				const o = {};
				const monthDate = getDateDataFromDateCode(
					group.month,
					this.isSmallDevice
				);
				o.headerText = monthDate?.formatted;
				o.headerId = `answers-${monthDate.month}-${monthDate.year}`;

				o.rows = group.answers.map((answer) => ({
					date: getDateDataFromDateCode(
						answer.date,
						this.isSmallDevice
					)?.formatted,
					index: answer.index,
					answer: answer.answer,
				}));

				return o;
			});
		},
	},
	mounted() {
		if (this.isClientMode) {
			getContextoAnswers(this.$axios, this.$config).then(
				(serviceResponse) => {
					this.todayData = serviceResponse?.today || null;
					this.pastData = serviceResponse?.past || [];
				}
			);
		}
	},
};
